/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NB_AUTH_OPTIONS,
  NbAuthSocialLink,
  NbAuthService,
  NbAuthResult,
} from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { NbStepperComponent, NbThemeService } from '@nebular/theme';
import { EMAIL_PATTERN, NUMBERS_PATTERN } from '../constants';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { TenantData } from '../../../@core/interfaces/masters/tenant';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { UserData } from '../../../@core/interfaces/common/users';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { AngularDeviceInformationService } from 'angular-device-information';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EzoTmplData } from '../../../@core/interfaces/masters/ezo-tmpl';
import { imageatch_detData } from '../../../@core/interfaces/masters/imageatch_det';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserModule , Title} from '@angular/platform-browser';
import { FaviconService } from '../../../favicon-service';
import { HospitalSettingsData } from '../../../@core/interfaces/masters/hospitalsettings';
import { DateService } from '../../../@theme/components/common/service/date.service';
// import * as countryCodeLists from '../../../../app/data/countryCode.json';
import { VopdService } from '../../../@core/backend/common/services/vopd.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class NgxLoginComponent implements OnInit {
  slides: any[] = new Array(3).fill({id: -1, src: '', title: '', subtitle: ''});
  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  redirectDelay: number = this.getConfigValue('forms.login.redirectDelay');
  showMessages: any = this.getConfigValue('forms.login.showMessages');
  strategy: string = this.getConfigValue('forms.login.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');
  rememberMe = this.getConfigValue('forms.login.rememberMe');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');
  isTenantIdRequired: boolean = this.getConfigValue('forms.validation.tenantId.required');
  isUserNameRequired: boolean = this.getConfigValue('forms.validation.userName.required');
  isMobileNumberRequired: boolean = this.getConfigValue('forms.validation.fullName.required');
  loginButtonClickCount: number = 1;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  tenantUser: any = {};
  adminChangedPassword: boolean = false;
  inActiveUser: boolean = false;
  resetSuccess: boolean = false;
  ActiveInActiveErrorMessage: string;
  passwordResetAlertMessage: string;
  submitted: boolean = false;
  tenantSubmitted: boolean = false;
  loginForm: FormGroup;
  adminChangePasswordForm: FormGroup;
  tenantLoginForm: FormGroup;
  alive: boolean = true;
  isFromTenantRegister: boolean = false;
  isUserLogin: boolean = false;
  isCustomerLogin: boolean = true;
  protected readonly unsubscribe$ = new Subject<void>();
  data: any;
  whiteLabelEnabled:boolean=true;
  hideLabelFlag:boolean=true;
  @Input() newTenant: any;
  fromPage: any;
  iscustomerError: boolean = false;
  customerIPAddress: string;
  subcriptionTypeError: boolean = false;
  newCustomerDialog: boolean = false;
  showTennatInfo: boolean = false;
  isForgotPassword: boolean = false;
  isOtpDia: boolean = false;
  isResetComp: boolean = false;
  resetMobileNum: any;
  customerName: string;
  userData: any;
  allowClear: any = true;
  multiple: boolean = false;
  placeholder: string = "Select";
  branchData: any[];
  pwdErrorMsg: string = "";
  mobileNumberDoesNotExists: boolean = false;
  images: any[];
  customerTenantLogo:string="../../../../assets/images/transparentimage.png";
  userMobileNumber:string;
  get fullName() { this.userMobileNumber=this.loginForm.get('fullName').value; return this.loginForm.get('fullName'); }
  get password() { return this.loginForm.get('password'); }
  get tenantId() { return this.tenantLoginForm?.get('tenantId'); }
  get tenantEmail() { return this.tenantLoginForm.get('tenantEmailId'); }
  loginScreen = true;
  bannerPic = false;
  showResetPasswordPage:boolean=false;
  bannersrcname1: string = "";
  bannersrcname2: string = "";
  bannersrcname3: string = "";
  bannerPicNotFound:boolean=false;
  resetpasswordbyadmin:string="resetpasswordbyadmin";
  countryCodeLists: Array<any>=[];
  
  langCode: number
  filteredTransDetails: any = {};
  isSubmitted = false;
  @ViewChild('stepper') stepperComponentInstance: NbStepperComponent;

  showPassword: boolean = false;
  organizationList: Array<any>[];
  locationList: any[]=[];
  loadLocation:Array<any>[]=[];
  currencyList:any[]=[];
  disShukheeLogo=false;
  env = environment;
  maxMobileNumberLength: number = 10;
  minMobileNumberLength: number = 10;
  branchCountryDetails:Array<any> = [];
  bloodSugarUnits:Array<any>=[];
  licenseExpired: boolean = false;
  
togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
}

  constructor(protected service: NbAuthService,protected hospSettingSrvc: HospitalSettingsData, private title: Title,protected userService: UserData,
    private deviceInformationService: AngularDeviceInformationService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected themeService: NbThemeService,
    private fb: FormBuilder,private dateService: DateService,
    protected router: Router, protected EzoeTmplSrvc: EzoTmplData, protected patRegSrvc: PatientRegistrationData, private iatchSrvc: imageatch_detData, private httpClient: HttpClient, protected rolesService: RolesData,
    protected initUserService: InitUserService, protected tenantSrvc: TenantData, private route: ActivatedRoute, private faviconService: FaviconService,private vopdSrvc: VopdService) {

    this.route.params.subscribe(params => {

      this.fromPage = params['newTenant'];
    });
  }

  ngOnInit(): void {
    this.loadBloodSugarTypes();
    this.skipValidatingCustomerIdByURL();
    const userNameValidators = [
    ];
    this.isUserNameRequired && userNameValidators.push(Validators.required);
    const tenantEmailValidators = [
      Validators.pattern(EMAIL_PATTERN),
    ];
    const mobileNumberValidators = [
      Validators.pattern(NUMBERS_PATTERN),
    ];
    this.isMobileNumberRequired && mobileNumberValidators.push(Validators.required);
    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);

    const tenantIdValidators = [
    ];
    this.isTenantIdRequired && tenantIdValidators.push(Validators.required);

    this.loginForm = this.fb.group({
      fullName: this.fb.control('', [...mobileNumberValidators]),
      password: this.fb.control('', [...passwordValidators]),
      rememberMe: this.fb.control(''),
      tenantId: this.fb.control(''),
      //New
      branchId: this.fb.control('', [Validators.required]),
      organization: this.fb.control(''),
      location: this.fb.control(''),

    });

    this.adminChangePasswordForm = this.fb.group({

      currentPassword: this.fb.control(''),
      newPassword: this.fb.control('', [...passwordValidators]),
      confirmPassword: this.fb.control('', [...passwordValidators]),
    });

    this.tenantLoginForm = this.fb.group({
      tenantId: this.fb.control('', [Validators.required, Validators.minLength(1), Validators.maxLength(12)]),
      tenantEmailId: this.fb.control('', [Validators.pattern(EMAIL_PATTERN)]),
    });
    this.loadGeo();
    this.loadCurrency();
    if (localStorage.getItem("skipValidTenant") == "true") {

      this.isCustomerLogin = false;
      this.isUserLogin = true;
      this.customerName = localStorage.getItem("customerName");
      this.loginForm.controls['fullName'].setValue(localStorage.getItem("currentUserMobileNumber"));
      this.getBranchDetailsByMobileNumber(localStorage.getItem("currentUserMobileNumber"));
    }
  }

  loadBloodSugarTypes(){
    this.rolesService?.list(`tenants/null/masterreason/null/GetEzoMasterById?type=BLOOD_SUGAR_TYPE&isActive=true`).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (data: any) => {
        if(data && data.details){
          this.bloodSugarUnits=data.details;
          }});
          }

  get apiUrl(): string {
    return environment.apiUrl;
  }
  get fval(): { [key: string]: AbstractControl } { return this.loginForm.controls; }
  get resetfval(): { [key: string]: AbstractControl } { return this.adminChangePasswordForm.controls; }

  onRequestPasswordClose(data: any): void {
    if (data == null) {
      this.isForgotPassword = false;
      this.isUserLogin = true;
    }
    else if (data.otpVerified == "approved" || data.otpVerified == "success") {
      this.resetMobileNum = data.resetMobileNum;
      this.isForgotPassword = false;

      this.isResetComp = true;
    }

  }

  skipValidatingCustomerIdByURL(){
    this.whiteLabelEnabled=false;
   const brandCode = environment.brandCode;
   if(brandCode.key == 'shukhee'){
      this.disShukheeLogo =true;
      this.title.setTitle(brandCode.value);

      setTimeout(() => {
        this.faviconService.updateFavicon(`assets/faviconshukhee.ico`);
      }, 2000);
  }else{
  this.tenantSrvc.validateCustomerByHostName(`auth/validateTenantBySourceUrl`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
  this.tenantSubmitted = false;
  if(data?.whiteLabel){
    this.data = data?.token;
    if (this.data != null) {
      this.title.setTitle(this.data?.name);
      this.getTenantBanner(this.data?.id);
      this.whiteLabelEnabled= this.data?.sourceUrl!=null?true:false;
      localStorage.setItem('isWhiteLabelCustomer',JSON.stringify(this.whiteLabelEnabled));

    localStorage.setItem('tenantUserId', this.data?.tenantUserId);
    localStorage.setItem('customerName', this.data?.name);
    localStorage.setItem('responseTenantId', this.data?.id);
    this.loginForm.controls['tenantId'].setValue(this.data?.id);
    this.customerName = localStorage.getItem("customerName");

    this.hideLabelFlag=this.data?.hideLabel=='Yes'?true:false;
    if(this.whiteLabelEnabled){
      this.faviconService.updateFavicon(this.customerTenantLogo);
    }else{
      this.faviconService.updateFavicon('favicon.png');
    }
   
    this.isCustomerLogin = false;
    this.isUserLogin = true;
  }
}
  else{
  this.hideLabelFlag= false;
    this.title.setTitle("Ezovion HMS");

    setTimeout(() => {this.faviconService.updateFavicon('favicon.ico');
  }, 2000);
  this.isCustomerLogin = true;
  this.isUserLogin = false;
  }

}, (error) => {
  this.whiteLabelEnabled=false;
  this.title.setTitle("Ezovion HMS");
  this.tenantSubmitted = false;
  this.cd.detectChanges();
  this.isCustomerLogin = true;
  this.isUserLogin = false;
}, () => {
 this.getSystemIPAddress();
  this.cd.detectChanges();
});
  }
  }
  onResetPasswordClose(data: any): void {
    this.errors = [];
    this.isResetComp = false;
    this.isCustomerLogin = true;
  }

  getTenantBanner(tenantId) {
    this.images=[];
    this.loginScreen = false;
    this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${tenantId}/${tenantId}/loginBanner`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data.length > 0){
        this.bannerPicNotFound = false;
        this.bannerPic = true;
        this.loginScreen = false;
        let bannerlogo = data.filter(e=>e.type=="wallpaper");
        let tenantLogo = data.filter(e=>e.type=="logo");
        if(tenantLogo.length > 0){
          this.customerTenantLogo=  'data:image/jpeg;base64,' + tenantLogo[(tenantLogo.length-1)].image;
        }
        if (bannerlogo.length > 0) {
          bannerlogo.forEach(e => {
            this.images.push({path:e.image='data:image/jpeg;base64,'+e.image}) ;
          });
        } else {
          this.loginScreen = false;
          this.bannerPicNotFound = true;
          this.bannerPic = false;

        }
        this.cd.detectChanges();

      }else{
        this.bannerPicNotFound = true;
        this.bannerPic = false;
        this.loginScreen = false;
      }


    }, (error) => {
      this.loginScreen = false;
      this.bannerPicNotFound = true;
      this.bannerPic = false;

    }, () => {
    });
  }

  forgotPassword() {
    this.isUserLogin = false;
    this.isForgotPassword = true;
    this.errors = [];
  }

  forgotCustomerPassword() {
    this.isUserLogin = false;
    this.isCustomerLogin = false;
    this.isForgotPassword = true;
  }
  backToTenant() {
    this.errors = [];
    this.isUserLogin = false;
    this.isCustomerLogin = true;
    this.showTennatInfo = false;
    this.mobileNumberDoesNotExists = false;
    this.loginForm.reset();
    this.errors.length = 0;
    this.bannerPic=false;
    this.bannerPicNotFound=false;
    this.loginScreen=true;
  }
  newCustomer() {
    this.newCustomerDialog = true;
  }
  onOtpDiaClose(data: any): void {
      if(data !=null && data!=undefined){

        if(data.otpStatus=="approved"){
          this.showResetPasswordPage=true;
          this.adminChangedPassword=false;
        }else{
          this.adminChangedPassword=false;
          this.showResetPasswordPage=false;

        }

      }else{
        this.adminChangedPassword=false;
        this.showResetPasswordPage=false;
      }
  }

  public getSystemIPAddress(): any {

    this.httpClient.get("https://geolocation-db.com/json/").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.customerIPAddress = data.IPv4;

      return data;
    }, (error) => {
    }, () => {
    });


  }

  tenantLogin(): void {
    this.isSubmitted = true;
    let userId = localStorage.getItem("wardUserId");
    let priceList = localStorage.getItem("wardWisePrice");
    localStorage.clear();
    window.localStorage.clear();
    localStorage.setItem("wardWisePrice", priceList);
    localStorage.setItem("wardUserId", userId);
    localStorage.setItem('isWhiteLabelCustomer',JSON.stringify(this.whiteLabelEnabled));
    this.iscustomerError = false;
    this.subcriptionTypeError = false;
    this.licenseExpired=false
    this.tenantUser = this.tenantLoginForm.value;
    this.errors = [];
    this.messages = [];
    this.tenantSubmitted = true;
    if(this.tenantLoginForm.valid){
         if (this.tenantLoginForm.get('tenantId').value != "75314167" && this.tenantLoginForm.get('tenantId').valid) {
      this.tenantSrvc.getTenantData(`${this.apiUrl}/auth/validtenant`, this.tenantUser).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.tenantSubmitted = false;
        this.data = data.token;
        if(!!data?.token?.id) this.getBranchWithCountryDet(data?.token?.id);
        if (this.data != null) {
            this.getTenantBanner(this.data.id);

            localStorage.setItem('isVOPD', this.data.isVOPD);
          localStorage.setItem('tenantUserId', this.data.tenantUserId);
          localStorage.setItem('customerName', this.data.name);
          localStorage.setItem('responseTenantId', this.data.id);
          this.loginForm.controls['tenantId'].setValue(this.data.id);
          this.customerName = localStorage.getItem("customerName");
          this.title.setTitle(this.env.brandCode.value);
          localStorage.setItem("combineOldBills", this.data?.combineOldBills);
          localStorage.setItem("updateConsultationType", this.data?.updateConsultationType);
          localStorage.setItem("allowServiceDiscWithHealthcard", this.data?.allowServiceDiscWithHealthcard);
          localStorage.setItem("loadPoProducts", this.data?.loadPoProducts);
        }
        if (!!this.data && this.data?.isVOPD === true) {
          this.loginForm.get('organization')?.setValidators([Validators.required]);
          this.loginForm.get('organization')?.updateValueAndValidity();
          this.loginForm.get('location')?.setValidators([Validators.required]);
          this.loginForm.get('location')?.updateValueAndValidity();
          // this.onload();
          // this.getAllOrgDetails();
        }else{
          this.loginForm.get('organization')?.clearValidators();
          this.loginForm.get('location')?.clearValidators();
        }

      }, (error) => {
        this.tenantSubmitted = false;
        this.iscustomerError = true;
        this.cd.detectChanges();
      }, () => {

        var test = this.getSystemIPAddress();
       
        if (this.data != null && this.data != undefined && this.data?.code== 403 && this.data?.message === 'License expired') {
          this.licenseExpired = true;
        }
        else if (this.data != null && this.data != undefined && this.data != "Your subscription was ends now ! Please communicate with Ezovion Administrator") {
          localStorage.setItem('responseTenantId', this.data.id);
          this.loginForm.controls['tenantId'].setValue(this.data.id);

          if (this.fromPage == "newtenant")
            this.router.navigate(['auth/register', this.data.tenantUserId]);
          else {
            this.isCustomerLogin = false;
            this.isUserLogin = true;
            if (this.loginForm.get('fullName').value != null && this.loginForm.get('fullName').value != undefined && this.loginForm.get('fullName').value != "")
              this.loginForm.controls['fullName'].setValue(this.loginForm.get('fullName').value);
          }
        }
        else {
          this.subcriptionTypeError = true;
        }
        this.cd.detectChanges();
      });
    }
    else {
      this.router.navigate(['auth/logout', this.tenantLoginForm.get('tenantId').value]);
      this.tenantSubmitted = false;

    } 
    }
  }
  loadCurrency(){
    if(this.currencyList.length > 0){
        this.currencyList = this.currencyList
    }else{
      this.patRegSrvc.list(`currency/getCurrencyMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.currencyList = data.details; }, (error) => {
    }, () => {
    });
    }
  }
  loadGeo(): void {
    if(this.countryCodeLists.length > 0){
         this.countryCodeLists= this.countryCodeLists
    }else{
    this.patRegSrvc.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryCodeLists = data.details;

    }, (error) => {
    }, () => {
    });
  }
  }

  cancelResetPasswordPage(){
    this.showResetPasswordPage=false;
  }

  cancelAdminPwdPopup() {
    this.adminChangedPassword = false;

  }

  

loadTenantInitialization(): void {
  try {
    const tenantId = this.loginForm.get('tenantId')?.value;
    const branchId = this.loginForm.get('branchId')?.value;

    if (!tenantId || !branchId) {
      return;
    }
    const currentTenant$ = this.patRegSrvc.list(`tenants/${tenantId}/tenantbranch/${branchId}`);
    const hospitalSettings$ = this.hospSettingSrvc.list(`${environment.apiUrl}/tenants/${tenantId}/${branchId}/hospitalsettings`);
    const storageProvider$ = this.hospSettingSrvc.roomRentList(`tenants/${tenantId}/tenantmst/getStorageProviderId`);

    forkJoin([currentTenant$, hospitalSettings$, storageProvider$])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ([tenantResp, hospitalResp, storageResp]) => {
    
          if (tenantResp) {
            this.data = tenantResp;
            localStorage.setItem('hospitalName', tenantResp.branchName);
            localStorage.setItem('HospitalMobile', tenantResp.contNum);
            localStorage.setItem('HospitalAddress', `${tenantResp.city} - ${tenantResp.pincode}`);
           
          }

          if (hospitalResp?.length > 0) {
            this.saveHospitalSettings(hospitalResp[0]);
          } else {
            localStorage.setItem("labOrderingFlag", 'No');
          }
          
          if (storageResp?.details) {
            localStorage.setItem("storageProvider", storageResp.details);
          }
        },
        error: (err) => {
        }
      });
  } catch (ex) {
  }
}

/** 
 * Helper to save hospital settings to localStorage
 */
private saveHospitalSettings(hospitalData: any): void {
  try {
    localStorage.setItem("hospitalSettingsData", JSON.stringify(hospitalData?.auto_RoomRent_Charges_Flag));
    localStorage.setItem("labResultAlert", hospitalData?.labResultAlert);
    localStorage.setItem("labReportTimelineFlag", hospitalData?.labReportTimelineFlag);
    localStorage.setItem("printTemplateSetting", hospitalData?.printTemplateSetting);
    localStorage.setItem("phDSCredit", hospitalData?.phDSCredit);
    localStorage.setItem("phIPCredit", hospitalData?.phIPCredit);
    localStorage.setItem("phOPCredit", hospitalData?.phOPCredit);
    localStorage.setItem("labtestnotesFlag", hospitalData?.labTestNotes);
    localStorage.setItem("labgroupnotesFlag", hospitalData?.labGrpNotes);
    localStorage.setItem("wardbasedserviceprice", hospitalData?.wardWisePriceSetting);
    localStorage.setItem("pharmacysalesgstshowstatus", hospitalData?.phhideGSTSalesPrint);
    localStorage.setItem("sessionTimeOutSettings", hospitalData?.sessionTimeOut);

    localStorage.setItem("vaccineService", hospitalData?.vaccineService);
    localStorage.setItem("registrationServiceId", hospitalData?.registrationServiceId);
    localStorage.setItem("autoPostRegistrationChargesFlag", hospitalData?.automaticPostCharges);
    localStorage.setItem("registrationCharge", hospitalData?.registrationCharge);
    localStorage.setItem("registrationDoctorId", hospitalData?.registrationDoctorId);

    localStorage.setItem("genarateBillBeforeCheckIn", hospitalData?.genarateBillBeforeCheckIn);
    localStorage.setItem("enableCheckInIfNoDues", hospitalData?.enableCheckInIfNoDues);
    localStorage.setItem("enableCheckOutIfNoDues", hospitalData?.enableCheckOutIfNoDues);
    localStorage.setItem("dischargeSummaryType", hospitalData?.dischargeSummaryType);
    localStorage.setItem("accessPatientAccrossAllbranches", hospitalData?.accessPatientAccrossAllbranches);
    localStorage.setItem("roomRentserviceId", hospitalData?.serviceId);
    localStorage.setItem("combineOldBills", hospitalData?.combineOldBills);
    localStorage.setItem("updateConsultationType", hospitalData?.updateConsultationType);
    localStorage.setItem("allowServiceDiscWithHealthcard", hospitalData?.allowServiceDiscWithHealthcard);
    localStorage.setItem("loadPoProducts", hospitalData?.loadPoProducts);

    localStorage.setItem("ipBillServiceDisplayOrderBy", hospitalData?.ipBillServiceDisplayOrderBy);
    localStorage.setItem("ipBillNotes", hospitalData?.ipBillNotes);
    localStorage.setItem("pharmacyBillIntegrationIPBill", hospitalData?.pharmacyBillIntegrationIPBill);
    localStorage.setItem("phIPService", hospitalData?.phIPService);
    localStorage.setItem("phIPDisplayMode", hospitalData?.phIPDisplayMode);
    localStorage.setItem("phIpDisplayFormat", hospitalData?.phIpDisplayFormat);
    localStorage.setItem("unitFlag", hospitalData?.unitFlag);
    localStorage.setItem("warehouseFlag", hospitalData?.warehouseFlag);
    localStorage.setItem("stockAlterDue", hospitalData?.stockAlterDue);
    localStorage.setItem("phBillMobileMandatory", hospitalData?.phBillMobileMandatory);
    localStorage.setItem("labOrderingFlag", hospitalData?.labOrderingFlag === 'Y' ? 'Yes' : 'No');
    localStorage.setItem("gstforFreeQty", hospitalData?.gstforFreeQty);
    localStorage.setItem("ipServicePagination", hospitalData?.ipServicePagination);

    localStorage.setItem("thresholdCommission",hospitalData?.thresholdCommission);
    localStorage.setItem("splitRevenueIfPartialPayment", hospitalData?.splitRevenueIfPartialPayment);
    localStorage.setItem("skipPhysicianRevenueIfOverDiscount", hospitalData?.skipPhysicianRevenueIfOverDiscount);

    /** ---- Handle JSON properties ---- */
    if (hospitalData?.multiPropertyJson) {
      const multiPropertyJsonValue = JSON.parse(hospitalData.multiPropertyJson);
      const otherPropertiesData = hospitalData?.otherPropertiesJson ? JSON.parse(hospitalData.otherPropertiesJson)  : {};

      localStorage.setItem("Walkin_Appointment_enable_Edit_after_checkin", multiPropertyJsonValue?.modifyCheckinData ?? 'Yes');
      localStorage.setItem("Walkin_Appointment_enable_Edit_after_checkOut", multiPropertyJsonValue?.modifyCheckoutData ?? 'Yes');
      localStorage.setItem("allowGSTinOpBill", multiPropertyJsonValue?.allowGSTinOpBill ?? 'No');
      localStorage.setItem("isOpBillGstInclusive", multiPropertyJsonValue?.isOpBillGstInclusive ?? 'No');
      localStorage.setItem("allowGSTinIpBill", multiPropertyJsonValue?.allowGSTinIpBill ?? 'No');

      const bloodSugarUnit = this.bloodSugarUnits.find(x => x.mrId === multiPropertyJsonValue?.bloodSugarUnit)?.reasonName;

      localStorage.setItem("bloodSugarUnit", bloodSugarUnit ?? 'mg/dL');
      localStorage.setItem("adviceLabelFlag", multiPropertyJsonValue?.adviceLabelFlag ?? false);
      localStorage.setItem("isIpBillGstInclusive", multiPropertyJsonValue?.isIpBillGstInclusive ?? 'No');
      localStorage.setItem("gstApplicableAfterDisc", multiPropertyJsonValue?.gstApplicableAfterDisc ?? 'No');
      localStorage.setItem("enableSalesScheme", multiPropertyJsonValue?.enableSalesScheme ?? 'No');
      localStorage.setItem("stopdischargeSummaryEditIP", multiPropertyJsonValue?.stopdischargeSummaryEditIP ?? 'No');
      localStorage.setItem("stopPharmacyCreditBillIP", multiPropertyJsonValue?.stopPharmacyCreditBillIP ?? 'No');
      localStorage.setItem("backDatedRegistration", multiPropertyJsonValue?.backDatedRegistration ?? 'No');
      localStorage.setItem("pharmacyMedDisc", otherPropertiesData?.Medicine_Discount ?? null);

      !!multiPropertyJsonValue?.ezoTemplate?localStorage.setItem("ezoTemplate",JSON.stringify(multiPropertyJsonValue?.ezoTemplate)):localStorage.setItem("ezoTemplate",JSON.stringify([]));
      !!multiPropertyJsonValue?.AssessmentTemplate?localStorage.setItem("AssessmentTemplate",JSON.stringify(multiPropertyJsonValue?.AssessmentTemplate)):localStorage.setItem("AssessmentTemplate",JSON.stringify([]));
      localStorage.setItem("ipRoomRentAutoPosting", multiPropertyJsonValue?.ipRoomRentAutoPosting ?? 'No');
    } else {
      // Defaults if no multiPropertyJson
      localStorage.setItem("Walkin_Appointment_enable_Edit_after_checkin", 'Yes');
      localStorage.setItem("Walkin_Appointment_enable_Edit_after_checkOut", 'Yes');
      localStorage.setItem("allowGSTinOpBill", 'No');
      localStorage.setItem("isOpBillGstInclusive", 'No');
      localStorage.setItem("allowGSTinIpBill", 'No');
      localStorage.setItem("isIpBillGstInclusive", 'No');
      localStorage.setItem("gstApplicableAfterDisc", 'No');
      localStorage.setItem("enableSalesScheme", 'No');
      localStorage.setItem("stopdischargeSummaryEditIP", 'No');
      localStorage.setItem("ipRoomRentAutoPosting", 'No');
      localStorage.setItem("stopPharmacyCreditBillIP", 'No');
      localStorage.setItem("pharmacyMedDisc", null);
      localStorage.setItem("ezoTemplate", JSON.stringify([]));
      localStorage.setItem("AssessmentTemplate", JSON.stringify([]));
    }
  } catch (ex) {
  }
}

  login(): void {
  
    if (!this.mobileNumberDoesNotExists) {
      this.submitted = true;
      if (this.loginForm.valid) {
        if (localStorage.getItem("responseTenantId") == null) {
          this.loginForm.controls["tenantId"].setValue(this.loginForm.get('tenantId').value);

        } else {
          this.loginForm.controls["tenantId"].setValue(localStorage.getItem("responseTenantId"));

        }
        this.user = this.loginForm.value;
        let createLogin = {
          "FullName": this.loginForm.get('fullName').value,
          "Password": this.loginForm.get('password').value,
          "TenantId": this.loginForm.get('tenantId').value,
          "BranchId": this.loginForm.get('branchId').value,
          "LoginCount": this.loginButtonClickCount++,
          "UserLoginSuccees": {
            "UserId": 0,
            "LoginTime": new Date(),
            "LogoutTime": "",
            "LogoutType": null,
            "LoginFrom": this.deviceInformationService.getDeviceType(),
            "Platform": this.deviceInformationService.getDeviceInfo().os + ' ' + this.deviceInformationService.getDeviceInfo().osVersion,
            "Device": this.deviceInformationService.getDeviceInfo().browser,
            "DeviceInfo": this.deviceInformationService.getDeviceInfo().browser,
            "IPAddress": this.customerIPAddress,
            "TenantId": this.loginForm.get('tenantId').value,
            "BranchId": this.loginForm.get('branchId').value,
          }

        }

        this.errors = [];
        this.messages = [];
        this.service.authenticate(this.strategy, createLogin).subscribe((result: NbAuthResult) => {
          this.submitted = false;
          this.inActiveUser = false;

          this.adminChangedPassword = false;

          localStorage.setItem("loginresult", JSON.stringify(result))
          if (result.isSuccess()) {
        
            this.loadTenantInitialization();
            this.messages = result.getMessages();
            localStorage.setItem("currentUserMobileNumber", this.loginForm.get('fullName').value);
            var userServiceData= this.initUserService.initCurrentUser().subscribe();
            localStorage.setItem("branchAccessList", JSON.stringify(this.userData));
            localStorage.setItem("branchId", this.loginForm.get('branchId').value);
            localStorage.setItem("loginOrganization", this.loginForm.get('organization').value);
            localStorage.setItem("loginLocation", this.loginForm.get('location').value);
            if (localStorage.getItem("skipValidTenant") != "true") {
              localStorage.setItem("ezovionAdmin", this.data.isSuperAdmin == "true" ? this.data.isSuperAdmin : "false");
            }
            localStorage.setItem("skipValidTenant", "false");
            localStorage.setItem("sessionId", result.getResponse().body.sessionId);
            localStorage.setItem('PreferredLanguage',  result.getResponse().body.preferredLanguage);
            localStorage.setItem("customerType", result.getResponse().body.customerType);
            let date=this.dateService.dateUtctoLocalDateAndTime(result.getResponse().body.renewalDate);
            localStorage.setItem("renewalDate", date.toDateString());
            this.langCode =  result.getResponse().body.preferredLanguage?result.getResponse().body.preferredLanguage:1001;
            this.getData()
            let branchId = this.loginForm.get('branchId')?.value; 
            let selectedUser = this.userData.find(user => user.id === branchId);
            if (selectedUser) {
                let taxType = selectedUser?.country_Mst?.taxType || 'GST'; 
                localStorage.setItem("taxType", taxType);
            }
          } else {
            if (result.getResponse()?.error?.message == 'Password Expired') {
              this.errors.push("Your password has been expired, please reset your password");
              this.forgotPassword();
            }
            else if (result.getResponse().status == 403)
              this.errors.push("Your account has been disabled, Please see your administrator");
            else if (result.getResponse()?.error?.message == 'Password Reset by Admin') {
              this.adminChangedPassword = true;
              if (this.password.value != null && this.password.value != undefined && this.password.value != "") {
                this.adminChangePasswordForm.controls['currentPassword'].setValue(this.password.value);
              }

            }
            else if (result.getResponse()?.error?.message == 'InActive Trial User') {
              this.inActiveUser = true;
              this.ActiveInActiveErrorMessage = "Your Trial account is on hold due to extended period of inactivity. Please contact Ezovion for activation.";
            } else if (result.getResponse()?.error?.message == 'InActive Live User') {
              this.inActiveUser = true;
              this.ActiveInActiveErrorMessage = "Due to extended period of inactivity we have temporarily put your account on hold for security reasons. Please contact Ezovion to activate.";

            }
            else if (result.getResponse()?.error?.message == 'UnAuthorizedHostName') {
              this.inActiveUser = true;
              this.ActiveInActiveErrorMessage = "Unauthorized IP Address";

            }
            else if (result.getErrors()[0] = "Login/Email combination is not correct, please try again.") {
              this.errors = result.getErrors();
              if (this.errors[0] = "Login/Email combination is not correct, please try again.") {
                this.errors[0] = "Incorrect Password, Please Enter the valid password";

              }
            }

          }

          const redirect = result.getRedirect();
          if (redirect) {
            setTimeout(() => {

              if (localStorage.getItem("isVOPD") == "true"){
                return this.router.navigateByUrl("pages/vopd/session_dashboard");
              }

              if (localStorage.getItem("ezovionAdmin") == "true"){
                return this.router.navigateByUrl("pages/masters/superAdmin-master-dashboard");

              }
              else{
                if(userServiceData){

                  if(localStorage.getItem("landingPageUrl")==null){
                    return this.router.navigateByUrl("pages/patientservices/app");
                  }
                  if(localStorage.getItem("userFlag")=="Physician"){
                    this.iatchSrvc.getById(`${environment.apiUrl}/physicians/${localStorage.getItem("tenantId")}/${localStorage.getItem("branchId")}/${localStorage.getItem("physicianId")}/GetPhyscianById`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

                      const deptName=encodeURIComponent(data?.department?.name);
                      let routingUrl=localStorage.getItem("landingPageUrl")+localStorage.getItem("physicianId")+"/"+deptName;
                      localStorage.setItem("academicRank",data?.academicRank);

                      return this.router.navigate([routingUrl], {
                        queryParams: {
                          restrictedPatientAppointments:data?.restrictedPatientAppointments,
                          deptId: data?.department?.id,
                          isDocLogIn:true
                        }
                      });
                    }, (error) => {

                    }, () => {
                    });
                  }
                  else{
                    if(localStorage.getItem("userFlag")=="Employee"){
                      this.iatchSrvc.getById(`${environment.apiUrl}/tenants/${localStorage.getItem("tenantId")}/${localStorage.getItem("branchId")}/employee/${localStorage.getItem("employeeId")}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                        let jobCategoryId = data.jobCategoryId
                        localStorage.setItem("jobCategoryId", jobCategoryId);
                      })
                    }
                    return this.router.navigateByUrl(localStorage.getItem("landingPageUrl"));

                  }
                }
              }
              //localStorage.getItem("landingPageUrl")
            //pages/patientservices/app

            }, this.redirectDelay);
          }
          this.cd.detectChanges();
        }, (error) => {
          if (error.error.message = "Password Expired") {
            this.errors.push("Your password has bee expired. Can u pls reset your password");
          }
        });
      }
      else {
        if (!this.mobileNumberDoesNotExists) {
          this.submitted = false;
          this.errors = [];
          this.errors.push("The credential you entered is incorrect.");
        }

      }
    }

  }

  getConfigValue(key: string): any {

    return getDeepFromObject(this.options, key, null);
  }

  resetPassword() {


    let n = this.adminChangePasswordForm.get('confirmPassword').value;
    let c = this.adminChangePasswordForm.get('newPassword').value;
    if (this.adminChangePasswordForm.valid) {
      if (n != null && n != undefined && n != "" && c != null && c != undefined && c != "") {
        if (n == c) {
          let resetPwdData = {
            mobileNumber: this.fullName.value,
            password: this.adminChangePasswordForm.get('newPassword').value,
            confirmPassword: this.adminChangePasswordForm.get('confirmPassword').value,
            tenantId: localStorage.getItem("responseTenantId"),
            isRequestByAdmin: false
          }

          let pwdCheckData = {
            fullName: this.fullName.value,
            password: this.adminChangePasswordForm.get('currentPassword').value,
            tenantId: localStorage.getItem("responseTenantId"),
            ChangePassword: resetPwdData
          }

          this.rolesService.create(`${this.apiUrl}/auth/changePasswordByUser`, pwdCheckData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {


            if (data.result == "Reset-success") {
              this.passwordResetAlertMessage = "Password Changes successfully..! Try Login now";
              this.resetSuccess = true;
              setTimeout(() => {
                this.resetSuccess = false;
                this.cancelResetPasswordPage();
              }, 4000);
              this.adminChangedPassword = false;

            }
            else if (data.result == "failed") {
              this.pwdErrorMsg = "Password you entered is invalid!";
            }


          }, (error) => {
          }, () => {
            this.cd.detectChanges();
          });

        }
      }
    }
  }

  getBranchWithCountryDet(tenantId) {
       this.userService.getBranchList(`countries/GetBranchwithCountryAnonymous?tenantId=${tenantId}`).pipe(takeUntil(this.unsubscribe$))
      .subscribe((response: any) => {
        this.branchCountryDetails = !!response?.details ? response?.details : []
          if(this.branchCountryDetails && this.branchCountryDetails.length > 0){
              const maxList = this.branchCountryDetails.filter(branch => !!branch?.countryId && !!branch?.maxMobileNumberLength);
              const minList = this.branchCountryDetails.filter(branch => !!branch?.countryId && !!branch?.minMobileNumberLength);
              this.maxMobileNumberLength = maxList.length > 0 ? maxList.reduce((acc, branch) => Math.max(acc, branch.maxMobileNumberLength), 0): 10;  
              this.minMobileNumberLength = minList.length > 0 ? minList.reduce((acc, branch) => Math.min(acc, branch.minMobileNumberLength), Infinity) : 10;  
          }
          else{
            this.maxMobileNumberLength = 10;
            this.minMobileNumberLength = 10;
          }
            const mobileNumberValidators = [Validators.pattern(NUMBERS_PATTERN),Validators.minLength(this.minMobileNumberLength), Validators.maxLength(this.maxMobileNumberLength)];
            this.isMobileNumberRequired && mobileNumberValidators.push(Validators.required);
            this.loginForm.get('fullName').setValidators(mobileNumberValidators)
            this.loginForm.get('fullName').updateValueAndValidity();
         
      }, (error) => {

      });
  }


  getBranchDetailsByMobileNumber(mobileNo) {
    if (mobileNo.length <= this.maxMobileNumberLength && mobileNo.length >= this.minMobileNumberLength) {
      this.userService.getBranchList(`users/mobile/${mobileNo}/${localStorage.getItem("responseTenantId")}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.userData = data;
        if (this.userData.length == 1) {
          this.loginForm.controls["branchId"].setValue(this.userData[0].id);
          localStorage.setItem('LoginCountryCode' , this.userData[0]?.mobileCountryCode);
          this.getCountryDet(this.userData[0]?.mobileCountryCode);
        }
        else {
          this.loginForm.controls["branchId"].setValue(null);
        }

      }, (error) => {

      }, () => {

      });
    }

  }

  getCountryDet(LoginCountryCode){
    const selectedCountry = this.countryCodeLists.find(val => val.countryCode === LoginCountryCode);
    const selectedCurrency = this.currencyList.find(val => val.currencyCntryId === selectedCountry?.id);
    if(selectedCountry && selectedCurrency){
    const selectedCountryDet ={
            code: selectedCountry?.countryCode,
            country: selectedCountry?.name,
            currency: selectedCurrency?.currencyName,
            currencyCode: selectedCurrency?.currencyCode, 
            currencyPlural: selectedCountry?.currencyPlural,
            iso: selectedCountry?.iso,
            symbol: selectedCurrency?.currencyCode }
    localStorage.setItem('LoginCountryDet',JSON.stringify(selectedCountryDet));
    }
  }

  branchSelection(det){
    localStorage.setItem('LoginCountryCode' , det[0]?.data?.mobileCountryCode);
    this.getCountryDet(det[0]?.data?.mobileCountryCode);
    this.setBranchMobileNumberValidators(det[0]?.data?.id);

  }

  setBranchMobileNumberValidators(branchId:string) {
      if(!!branchId){
        const branchDetails = this.branchCountryDetails.find(branch => branch?.id === branchId);
        if (branchDetails) {
          this.maxMobileNumberLength = branchDetails?.maxMobileNumberLength || 10;
          this.minMobileNumberLength = branchDetails?.minMobileNumberLength || 10;
          this.loginForm.get('fullName').clearValidators();
          this.loginForm.get('fullName').setValidators([
            Validators.required,
            Validators.pattern(NUMBERS_PATTERN),
            Validators.minLength(this.minMobileNumberLength),
            Validators.maxLength(this.maxMobileNumberLength)
          ]);
          this.loginForm.get('fullName').updateValueAndValidity();
        } 
      }
  }

  orgSelection(event: any, type: string): void {
    if (event && event[0] && type === 'org') {
      const organizationId = event[0]?.value;
      this.loginForm.get('organization').setValue(organizationId);
      this.loadLocation = this.locationList?.filter(x => x?.organizationId === organizationId);
    } 
    else if (type !== 'loc') {
      this.loginForm.get('organization').setValue(null);
      this.loadLocation = this.locationList;
    }
    if (event && event[0] && type === 'loc') {
      const locationId = event[0]?.value;
      const organizationId = event[0]?.data?.organizationId;
      this.loadLocation = this.locationList?.filter(x => x?.organizationId === organizationId);
      
      this.loginForm.get('location').setValue(locationId);
      this.loginForm.get('organization').setValue(organizationId);
    } else  if (type !== 'org')  {
      if(!!this.loginForm.get('organization').value)
        this.loadLocation = this.locationList?.filter(x => x?.organizationId === this.loginForm.get('organization').value);
       else
        this.loadLocation = this.locationList;
    }
  }
  getAllOrgDetails(){
    let det;
    const params = new HttpParams().set('tenantId',this.loginForm.get('tenantId').value).set('branchId',this.loginForm.get('branchId').value);
    this.vopdSrvc.list(`OrganizationMaster/GetallVOPDOrganizationMaster`,params).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
       det = response;
    }, (error) => {
    },()=>{
      this.organizationList = det.details;
    });
  }
  onload() {
    this.hospSettingSrvc.list(`${environment.apiUrl}/VisitLocationMst/GetVisitLocationMst?tenantId=` + this.loginForm.get('tenantId').value + '&branchId=' + this.loginForm.get('branchId').value).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data.details.length>0){
      const det = data?.details.map((x)=>{return x?.locationdata});
      this.locationList = det;
      this.loadLocation = det;
      }
      
      })
  }  
  saverange(x) {
    if (x.target.value.length <= this.maxMobileNumberLength && x.target.value.length >= this.minMobileNumberLength) {
      var mobileNo = x.target.value;
      this.userService.getBranchList(`users/mobile/${mobileNo}/${localStorage.getItem("responseTenantId")}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.userData = data;
        if (this.userData.length == 1) {
          this.loginForm.controls["branchId"].setValue(this.userData[0].id);
          localStorage.setItem('LoginCountryCode' , this.userData[0]?.mobileCountryCode);
          this.getCountryDet(this.userData[0]?.mobileCountryCode);
          this.mobileNumberDoesNotExists = false;
        }
        else if (this.userData.length == 0) {
          this.loginForm.controls["branchId"].setValue(null);
          this.mobileNumberDoesNotExists = true;
        } else if (this.userData.length > 1) {
          this.loginForm.controls["branchId"].setValue(null);
          this.mobileNumberDoesNotExists = false;
        }

      }, (error) => {

      }, () => {
        if(!!this.loginForm.get("branchId").value && this.data?.isVOPD === true ){
          this.onload();
          this.getAllOrgDetails();
        }

      });
    }
    else {

    }
  }

  getData() {
    this.patRegSrvc.list('Translation/LanguageMst?loadLangData=false').pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      const master = data.master;
      if( this.langCode !== undefined){
      this.filteredTransDetails = data.detail
        .filter(detail => detail.languageID == this.langCode)
        .reduce((acc, detail) => {
          const originalText = master.find(item => item.languageVariableId == detail.transMst.languageVariableID)?.originalText;
          if (originalText && this.langCode && detail.translatedText) {
            acc[originalText?.trim()] = detail.translatedText?.trim();
          }else{
            acc[originalText?.trim()] = detail.originalText?.trim();
          }
          return acc;
        }, {} as Record<string, string>);}else{
          this.filteredTransDetails = data.detail.reduce((acc, detail) => {
            const originalText = master.find(item => item.languageVariableId == detail.transMst.languageVariableID)?.originalText;
            acc[originalText?.trim()] = originalText?.trim();
            return acc;
          }, {} as Record<string, string>);
        }
        localStorage.setItem("Labels",JSON.stringify(this.filteredTransDetails))
    });
  }

}
